var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChessBlackQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 898 953",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-57,-22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13516,0,0,1.13516,-68.3904,-48.0781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chess_blackQ",
    d: "M190,153C149.736,152.864 130.747,188.584 131,219C131.253,249.416 167.309,296.725 199,283C208.601,336.482 229.633,266.354 236,563C237.255,609.536 271.651,709.545 349,773C313.735,772.661 326.644,772.763 269,774C200.879,775.462 196.81,883.092 273,881C337.708,879.223 673.933,877.919 748,877C823.065,876.069 814.84,775.49 745,774C681.172,772.638 665,773 665,773C746.927,691.805 773.562,661.186 782,558C790.438,454.814 780.239,310.202 815,280C847.391,287.64 880.436,256.679 881,218C881.579,178.27 858.843,156.718 826,155C793.157,153.282 751.809,180.451 766,239C732.378,267.907 693.005,318.696 668,370C643.252,290.36 638.431,294.402 639,214C672.85,186.473 672.123,162.86 671,147C669.173,121.204 652.475,80.925 611,82C565.572,83.177 549.492,123.695 549,146C548.508,168.305 553.461,188.546 573,205C554.779,265.053 543.023,271.605 510,382C459.608,267.042 449.521,257.545 443,205C466.335,186.277 469.421,157.545 468,140C466.579,122.455 455.748,80.566 405,82C357.105,83.353 345.071,130.663 346,148C346.929,165.337 362.267,196.543 383,210C355.74,265.689 360.421,325.05 358,373C314.777,330.343 316.329,303.763 248,255C274.071,212.702 251.493,153.208 190,153Z",
    style: {
      stroke: "black",
      strokeWidth: "40.38px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessBlackQ);
export default __webpack_public_path__ + "static/media/chess_blackQ.33eaf45620ab6870544766ab21ce66e3.svg";
export { ForwardRef as ReactComponent };